// tslint:disable
export var CampaignAttemptStatus;
(function (CampaignAttemptStatus) {
    // UNKN
    CampaignAttemptStatus[CampaignAttemptStatus["UNKN"] = 10001] = "UNKN";
    // SUCC
    CampaignAttemptStatus[CampaignAttemptStatus["SUCC"] = 10002] = "SUCC";
    // CFAIL
    CampaignAttemptStatus[CampaignAttemptStatus["CFAIL"] = 10003] = "CFAIL";
    // INADD
    CampaignAttemptStatus[CampaignAttemptStatus["INADD"] = 10004] = "INADD";
    // NOTDEL
    CampaignAttemptStatus[CampaignAttemptStatus["NOTDEL"] = 10005] = "NOTDEL";
    // Initiated
    CampaignAttemptStatus[CampaignAttemptStatus["Initiated"] = 10006] = "Initiated";
    // DocumentGenerated
    CampaignAttemptStatus[CampaignAttemptStatus["DocumentGenerated"] = 10007] = "DocumentGenerated";
    // FaxSubmitted
    CampaignAttemptStatus[CampaignAttemptStatus["FaxSubmitted"] = 10008] = "FaxSubmitted";
    // FaxSuccessful
    CampaignAttemptStatus[CampaignAttemptStatus["FaxSuccessful"] = 10009] = "FaxSuccessful";
    // FaxFailure
    CampaignAttemptStatus[CampaignAttemptStatus["FaxFailure"] = 10010] = "FaxFailure";
    // Shipped
    CampaignAttemptStatus[CampaignAttemptStatus["Shipped"] = 10011] = "Shipped";
    // PrintQueued
    CampaignAttemptStatus[CampaignAttemptStatus["PrintQueued"] = 10012] = "PrintQueued";
    // Void
    CampaignAttemptStatus[CampaignAttemptStatus["Void"] = 10013] = "Void";
    // Printed
    CampaignAttemptStatus[CampaignAttemptStatus["Printed"] = 10014] = "Printed";
    // PrintFailed
    CampaignAttemptStatus[CampaignAttemptStatus["PrintFailed"] = 10015] = "PrintFailed";
    // InboundSMSProcessed
    CampaignAttemptStatus[CampaignAttemptStatus["InboundSMSProcessed"] = 20007] = "InboundSMSProcessed";
    // EmailSuccessful
    CampaignAttemptStatus[CampaignAttemptStatus["EmailSuccessful"] = 30013] = "EmailSuccessful";
    // EmailFailure
    CampaignAttemptStatus[CampaignAttemptStatus["EmailFailure"] = 30014] = "EmailFailure";
    // SMSSucessfull
    CampaignAttemptStatus[CampaignAttemptStatus["SMSSucessfull"] = 30015] = "SMSSucessfull";
    // SMSFailure
    CampaignAttemptStatus[CampaignAttemptStatus["SMSFailure"] = 30016] = "SMSFailure";
    // PendingVendor
    CampaignAttemptStatus[CampaignAttemptStatus["PendingVendor"] = 30017] = "PendingVendor";
    // PrintRejected
    CampaignAttemptStatus[CampaignAttemptStatus["PrintRejected"] = 30018] = "PrintRejected";
    // DocGenFailed
    CampaignAttemptStatus[CampaignAttemptStatus["DocGenFailed"] = 30019] = "DocGenFailed";
    // FileCopyFailed
    CampaignAttemptStatus[CampaignAttemptStatus["FileCopyFailed"] = 30020] = "FileCopyFailed";
    // InvalidSecondaryDoc
    CampaignAttemptStatus[CampaignAttemptStatus["InvalidSecondaryDoc"] = 30021] = "InvalidSecondaryDoc";
    // DocStoreFailed
    CampaignAttemptStatus[CampaignAttemptStatus["DocStoreFailed"] = 30022] = "DocStoreFailed";
    // NeedsReview
    CampaignAttemptStatus[CampaignAttemptStatus["NeedsReview"] = 30023] = "NeedsReview";
    // UnderReview
    CampaignAttemptStatus[CampaignAttemptStatus["UnderReview"] = 30024] = "UnderReview";
    // DocumentRejected
    CampaignAttemptStatus[CampaignAttemptStatus["DocumentRejected"] = 30025] = "DocumentRejected";
    // DocumentApproved
    CampaignAttemptStatus[CampaignAttemptStatus["DocumentApproved"] = 30026] = "DocumentApproved";
    // Order_Acknowledged
    CampaignAttemptStatus[CampaignAttemptStatus["OrderAcknowledged"] = 30027] = "OrderAcknowledged";
    // Order_Closed
    CampaignAttemptStatus[CampaignAttemptStatus["OrderClosed"] = 30028] = "OrderClosed";
    // Order_Damaged
    CampaignAttemptStatus[CampaignAttemptStatus["OrderDamaged"] = 30029] = "OrderDamaged";
    // Order_Open
    CampaignAttemptStatus[CampaignAttemptStatus["OrderOpen"] = 30030] = "OrderOpen";
    // Order_OrderFailed
    CampaignAttemptStatus[CampaignAttemptStatus["OrderOrderFailed"] = 30031] = "OrderOrderFailed";
    // Order_PendVendor
    CampaignAttemptStatus[CampaignAttemptStatus["OrderPendVendor"] = 30032] = "OrderPendVendor";
    // Order_Returned
    CampaignAttemptStatus[CampaignAttemptStatus["OrderReturned"] = 30033] = "OrderReturned";
    // Order_UnverifAddr
    CampaignAttemptStatus[CampaignAttemptStatus["OrderUnverifAddr"] = 30034] = "OrderUnverifAddr";
    // Order_Void
    CampaignAttemptStatus[CampaignAttemptStatus["OrderVoid"] = 30035] = "OrderVoid";
})(CampaignAttemptStatus || (CampaignAttemptStatus = {}));
CampaignAttemptStatus['INITIATED'] = 10006;
CampaignAttemptStatus['DOCUMENTGENERATED'] = 10007;
CampaignAttemptStatus['FAXSUBMITTED'] = 10008;
CampaignAttemptStatus['FAXSUCCESSFUL'] = 10009;
CampaignAttemptStatus['FAXFAILURE'] = 10010;
CampaignAttemptStatus['SHIPPED'] = 10011;
CampaignAttemptStatus['PRINTQUEUED'] = 10012;
CampaignAttemptStatus['VOID'] = 10013;
CampaignAttemptStatus['PRINTED'] = 10014;
CampaignAttemptStatus['PRINTFAILED'] = 10015;
CampaignAttemptStatus['INBOUNDSMSPROCESSED'] = 20007;
CampaignAttemptStatus['EMAILSUCCESSFUL'] = 30013;
CampaignAttemptStatus['EMAILFAILURE'] = 30014;
CampaignAttemptStatus['SMSSUCESSFULL'] = 30015;
CampaignAttemptStatus['SMSFAILURE'] = 30016;
CampaignAttemptStatus['PENDINGVENDOR'] = 30017;
CampaignAttemptStatus['PRINTREJECTED'] = 30018;
CampaignAttemptStatus['DOCGENFAILED'] = 30019;
CampaignAttemptStatus['FILECOPYFAILED'] = 30020;
CampaignAttemptStatus['INVALIDSECONDARYDOC'] = 30021;
CampaignAttemptStatus['DOCSTOREFAILED'] = 30022;
CampaignAttemptStatus['NEEDSREVIEW'] = 30023;
CampaignAttemptStatus['UNDERREVIEW'] = 30024;
CampaignAttemptStatus['DOCUMENTREJECTED'] = 30025;
CampaignAttemptStatus['DOCUMENTAPPROVED'] = 30026;
CampaignAttemptStatus['ORDERACKNOWLEDGED'] = 30027;
CampaignAttemptStatus['ORDERCLOSED'] = 30028;
CampaignAttemptStatus['ORDERDAMAGED'] = 30029;
CampaignAttemptStatus['ORDEROPEN'] = 30030;
CampaignAttemptStatus['ORDERORDERFAILED'] = 30031;
CampaignAttemptStatus['ORDERPENDVENDOR'] = 30032;
CampaignAttemptStatus['ORDERRETURNED'] = 30033;
CampaignAttemptStatus['ORDERUNVERIFADDR'] = 30034;
CampaignAttemptStatus['ORDERVOID'] = 30035;
//# sourceMappingURL=CampaignAttemptStatus.js.map